<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Norm-Center" id="auto_bookmark_toc_1">For Kristin, Caraway, Hunter, Ruth, and everyone else who answers when I ask, “Do you think werewolves can…?” Thanks for feeding the creative fires!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?6bdfef5f